<template>
	<div class="onlineExamSuccess">
		<img src="@/assets/images/faceSuccessful.png" alt="" />
		<p v-if="!typeName">答案已经提交成功，{{ times }}s后自动返回</p>
		<p v-else>系统检查到非法操作，已自动提交试卷，{{ times }}s后自动返回</p>
		<el-button type="primary" @click="isRouter()">返回</el-button>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'onlineExamSuccess',
	data() {
		return {
			times: 10,
			typeName: '',
			shopTime: ''
		};
	},
	computed: {
		...mapState('permission', {
			_ENTRANCETYPE: state => state._ENTRANCETYPE
		})

	},
	mounted() {
		this.setTimes();
		this.typeName = this.$route.query.type;
	},
	methods: {
		isRouter() {
			clearInterval(this.shopTime);
			this.goToParticipateTest();
		},
		setTimes() {
			this.shopTime = setInterval(() => {
				this.times--;
				if (this.times === 1) {
					clearInterval(this.shopTime);
					this.goToParticipateTest();
				}
			}, 1000);
		},
		// 跳转我的考试
		goToParticipateTest(){
			let type = '';
			if(this._ENTRANCETYPE === 'own'){
				type = 'Own';
			}else if(this._ENTRANCETYPE === 'adult'){
				type = 'Adult';
			}
			this.$router.replace(`/participateTest${type}`);
		}
	}
};
</script>

<style scoped>
.onlineExamSuccess {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 100px;
}
.onlineExamSuccess p {
	font-size: 20px;
	color: #333;
	margin: 20px 0 50px;
}
</style>
